module.exports = __webpack_public_path__ + "img/check.c2ebbf46.svg";